import {
  UserEmploymentHistory,
  UserEmploymentHistoryRequest,
} from '@backrs_ui/grow-ui/src/redux/userPortfolio/userEmploymentHistory.api';

import { WORK_EXPERIENCE_FIELDS } from './questions.config';
import { FormValue, FormValues } from './types';
import { convertDateToString, convertStringValue, convertDateFromString } from './utils';

export const convertValueForEmploymentHistory = (
  column: string,
  values: FormValue[],
): string | number | boolean | number[] | undefined => {
  if (values.length === 0) return undefined;

  const value = values[0];

  switch (column) {
    case 'employer_name':
    case 'employer_city':
    case 'employer_state':
    case 'job_title':
      return convertStringValue(value);

    case 'start_date':
    case 'end_date':
      return convertDateToString(value);

    default:
      return convertStringValue(value);
  }
};

export const buildEmploymentHistoryFromFormValues = (
  formValues: FormValues,
  employerId?: number,
): UserEmploymentHistoryRequest => {
  const employmentHistoryData = WORK_EXPERIENCE_FIELDS.reduce((acc, field) => {
    if (!field.employmentHistoryKey || !formValues[field.key]) return acc;

    const value = convertValueForEmploymentHistory(
      field.employmentHistoryKey,
      formValues[field.key],
    );

    if (value !== undefined) {
      return {
        ...acc,
        [field.employmentHistoryKey]: value,
      };
    }

    return acc;
  }, {} as UserEmploymentHistoryRequest);

  return employerId ? { ...employmentHistoryData, employer_id: employerId } : employmentHistoryData;
};

export const prePopulateFormWithEmploymentHistory = (
  existingEmploymentHistory: UserEmploymentHistory[],
  questionNumber: number,
): {
  employmentHistoryId: number;
  formValues: FormValues;
  selectedEmployerName: string;
} | null => {
  const targetIndex = questionNumber - 1; // since the array is 0-indexed
  const targetEntry = existingEmploymentHistory[targetIndex];

  if (!targetEntry) return null;

  return WORK_EXPERIENCE_FIELDS.reduce(
    (acc, field) => {
      if (!field.employmentHistoryKey) return acc;

      const employmentHistoryValue = targetEntry[field.employmentHistoryKey];

      if (employmentHistoryValue === undefined || employmentHistoryValue === null) return acc;

      switch (field.employmentHistoryKey) {
        case 'employer_name':
          return {
            ...acc,
            formValues: {
              ...acc.formValues,
              [field.key]: [employmentHistoryValue as string],
            },
            selectedEmployerName: employmentHistoryValue as string,
          };

        case 'employer_city':
        case 'employer_state':
        case 'job_title':
        case 'achievements':
          return {
            ...acc,
            formValues: {
              ...acc.formValues,
              [field.key]: [employmentHistoryValue as string],
            },
          };
        case 'start_date':
        case 'end_date':
          return {
            ...acc,
            formValues: {
              ...acc.formValues,
              [field.key]: [convertDateFromString(employmentHistoryValue as string)],
            },
          };
        default:
          return acc;
      }
    },
    {
      employmentHistoryId: targetEntry.id,
      formValues: {} as FormValues,
      selectedEmployerName: '',
    },
  );
};
